module.exports = __webpack_public_path__ + "fonts/Veneer.3a2bca42.woff2";